import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '@efexteam/components';
import { check } from '../../../../../assets';
import { formatCurrency } from '../../../../../utils/formater';
import { WalletsStyles } from '../wallets.styles';
import { ConfirmedDataProps, ConversionDataProps } from './SelectCurrencies';

interface IConfirmedData {
  shouldReload: () => void;
  data: ConfirmedDataProps;
  conversionData: ConversionDataProps;
}

const ConfirmedData = ({
  shouldReload,
  data,
  conversionData,
}: IConfirmedData) => {
  const { t } = useTranslation();
  const { amount, amountConverted } = conversionData;
  const { reverse, currency, desCurrency } = data;
  return (
    <Box>
      <Box className={WalletsStyles.confirmCheckWrapper}>
        <img style={{ maxWidth: '30px' }} src={check} alt="transaction ready" />
      </Box>
      <Typography variant="h6" style={{ textAlign: 'center' }}>
        {t('walletConvertSuccess')}
      </Typography>
      <Box style={{ marginTop: '1rem' }}>
        <Box className={WalletsStyles.confirmRow}>
          <Typography variant="subtitle1">{t('walletFromText')}</Typography>
          <Typography variant="body1">
            {formatCurrency(reverse ? amountConverted : amount)} {currency}
          </Typography>
        </Box>
        <Box className={WalletsStyles.confirmRow}>
          <Typography variant="subtitle1">{t('walletToText')}</Typography>
          <Typography variant="body1">
            {formatCurrency(reverse ? amount : amountConverted)} {desCurrency}
          </Typography>
        </Box>
      </Box>
      <Box className="flex justify-center mt-4">
        <Button appearance="primary" variant="outlined" onClick={shouldReload}>
          {t('close')}
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmedData;
